import axiosInstance from "../utils/axios";

const readModel = async <T>(path: string): Promise<T> => {
	const response = await axiosInstance.get<T>(path);
	return response.data;
};

const readCollection = async <T>(path: string, filter: any = null): Promise<T> => {
	const response = filter
		? await axiosInstance.get<T>(path, { params: filter })
		: await axiosInstance.get<T>(path);

	return response.data;
};

const modelService = {
	readModel,
	readCollection
};

export default modelService;
